<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="80%">
    <template v-slot:title>Process Log Details</template>
    <v-container>
      <v-timeline :dense="$vuetify.breakpoint.smAndDown" reverse>
        <v-timeline-item
          v-for="(item, i) in items"
          :key="i"
          :color="stepColor(item.stepName)"
          icon="mdi-clock"
          ><template v-slot:opposite>
            <span class="title" v-text="item.createdAtTime"></span>
          </template>
          <v-card :color="stepColor(item.stepName)" dark>
            <v-card-title class="text-h6"
              ><v-icon dark size="42" class="mr-4">{{
                stepIcon(item.stepName)
              }}</v-icon
              >{{ item.stepName }}</v-card-title
            >
            <v-card-text class="white text--primary">
              <v-container>
                <v-card light outlined>
                  <v-card-title class="text-h6"
                    ><v-icon left>mdi-arrow-right-bold-box-outline</v-icon
                    >Input:</v-card-title
                  >
                  <v-card-text>
                    <div v-html="item.plainTextInput"></div>
                  </v-card-text>
                </v-card>
                <v-card class="mt-4" light outlined>
                  <v-card-title class="text-h6"
                    ><v-icon left>mdi-arrow-left-bold-box-outline</v-icon
                    >Output:</v-card-title
                  >
                  <v-card-text>
                    <div v-html="item.plainTextOutput"></div>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-container>
    <v-row v-if="debug">
      <v-col>
        <code>{{ processLog }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../shared/BasicDialog.vue";
const PROCESS_LOG_DETAILS_QUERY = gql`
  query processLogDetails($id: ID!) {
    processLog(id: $id) {
      status
      source
      name
      processLogNodes {
        id
        createdAtDate
        createdAtTime
        stepName
        plainTextInput
        plainTextOutput
      }
    }
  }
`;
const COLORS = {
  itinerary_details_question: "info",
  extract_itinerary_details: "green",
  parse_itinerary_details: "cyan",
};
const ICONS = {
  itinerary_details_question: "mdi-help",
  extract_itinerary_details: "mdi-file-document-edit",
  parse_itinerary_details: "mdi-file-document-edit",
};
export default {
  components: { BasicDialog },
  name: "process-log-details-dialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      debug: false,
    };
  },

  computed: {
    items() {
      return this.processLog ? this.processLog.processLogNodes : [];
    },
  },
  methods: {
    stepIcon(stepName) {
      return ICONS[stepName.toLowerCase()]
        ? ICONS[stepName.toLowerCase()]
        : "mdi-information";
    },
    stepColor(stepName) {
      return COLORS[stepName.toLowerCase()]
        ? COLORS[stepName.toLowerCase()]
        : "info";
    },
  },
  apollo: {
    processLog: {
      query: PROCESS_LOG_DETAILS_QUERY,
      variables() {
        return { id: this.value.id };
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.value || !this.value.id || !this.show;
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/plugins/process-logs/ProcessLogDetailsDialog.vue